module.exports = __webpack_public_path__ + "static/img/logo.8b8c195.png";